import { useEffect, useState } from "react";
import Button from 'react-bootstrap/Button'
import axios from "axios";

const CleanupServerMedia = () => {
  const [state, setState] = useState({
    mediaType: 'messages',
    mediaExt: 'mp4',
    date: ''
  });

  const handleFindMedias = () => {
    getMedias();
  }


  const getMedias = async() => {
    const {mediaType, mediaExt, date} = state;

    await axios.get('/api/administration/medias', {
      params: {
        media_type: mediaType,
        media_ext: mediaExt,
      }
    }).then(response => {
      console.log(response.data)
    }).catch(error => {
      console.log(error)
    })
  }
  
  return (
    <div>
        <h3 className="mb-4">Cleanup Server Media Files Not Used by PUs</h3>
        <div className="border-bottom mb-4">
          <div className="my-1 w-25">
            <p>Select the file Media location to Analyze</p>
            <select
              id="mediaType"
              value={state.mediaType}
              onChange={(e) => setState({...state, mediaType: e.target.value})}
            >
              <option value="messages">Messages</option>
              <option value="posts">Posts</option>
              <option value="stories">Stories</option>
            </select>
            <select
              className="mt-4"
              id="mediaExt"
              value={state.mediaExt}
              onChange={(e) => setState({...state, mediaExt: e.target.value})}
            >
              <option value="mp4">mp4</option>
              <option value="mov">mov</option>
              <option value="both">both</option>
            </select>
            <input
              className="mt-1 mb-4"
              type="text"
              placeholder="Year/Month"
              onChange={(e) => setState(e.target.value)}
              value={state.date}
            />
            <Button variant="primary" className="w-100 mw-100 mb-4" onClick={handleFindMedias}>
              Start Finding Media Files
            </Button>
          </div>
        </div>

        <div>
          <h4 className="mb-4">Settings</h4>
          <Button variant="primary" style={{maxWidth: 500}}>
            Set the Backup Volume Path
          </Button>
        </div>
    </div>
  )
}

export default CleanupServerMedia;